export default "__VITE_ASSET__eff40e48__"